// @flow

function atob(str: string): string {
  return __SERVER__ ? Buffer.from(str, 'base64').toString() : window.atob(str);
}

function btoa(str: string): string {
  return __SERVER__ ? Buffer.from(str).toString('base64') : window.btoa(str);
}

export function encode(str: string): string {
  return __SERVER__ ? btoa(str) : btoa(unescape(encodeURIComponent(str)));
}

export function decode(str: string): string {
  return __SERVER__ ? atob(str) : decodeURIComponent(escape(atob(str)));
}

const findBase64 = /(\{\{base64:[^}]+\}\})/g;
const wrapper = /\{\{base64:|\}\}/g;

export function decodeMarkup(str: string): string {
  return str.replace(findBase64, match => decode(match.replace(wrapper, '')));
}

export function removeMarkup(str: string): string {
  return str.replace(findBase64, '');
}
